import { render, staticRenderFns } from "./VoteListInfo.vue?vue&type=template&id=19e5c5d2&scoped=true&"
import script from "./VoteListInfo.vue?vue&type=script&lang=js&"
export * from "./VoteListInfo.vue?vue&type=script&lang=js&"
import style0 from "./VoteListInfo.vue?vue&type=style&index=0&id=19e5c5d2&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "19e5c5d2",
  null
  
)

export default component.exports